export default "__VITE_ASSET__dOjtz8pL__"